"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isElementVisible = exports.getKeyboardFocusableElements = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var isElementVisible = function isElementVisible(element) {
  var style = window.getComputedStyle(element);
  return style.display !== 'none' && style.visibility !== 'hidden';
};
exports.isElementVisible = isElementVisible;
var getKeyboardFocusableElements = function getKeyboardFocusableElements(element) {
  var hasVisibleParents = function hasVisibleParents(el) {
    var parentElement = el.parentElement;
    while (parentElement) {
      if (!isElementVisible(parentElement) || parentElement.getAttribute('aria-hidden') === 'true') {
        return false;
      }
      parentElement = parentElement.parentElement;
    }
    return true;
  };
  return _toConsumableArray(element.querySelectorAll('a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])')).filter(function (el) {
    return !el.hasAttribute('disabled') && el.getAttribute('aria-hidden') !== 'true' && isElementVisible(el) && hasVisibleParents(el);
  });
};
exports.getKeyboardFocusableElements = getKeyboardFocusableElements;